const data = {
  id: 1,
  title: 'Listen and arrange the sentences with the corresponding sound.',
  subTitle: 'Nghe và sắp xếp câu với âm thanh tương ứng.',
  question: '',
  answers: [
    { id: 1, answer: 'The bear is sleeping under the tree', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/810f185a-23ee-4067-b2dc-d29eed41cd21.mp3' },
    { id: 2, answer: 'The hippo is swimming very slowly', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/b181cb2d-09d0-47c6-8021-930174e243d0.mp3' },
    { id: 3, answer: 'The cat is playing with the woolen roll', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/0c535b1d-93cc-42ae-a0d3-fb82f16381cb.mp3' },
  ],
};

export default data;
